"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShoppingBagPopover = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const flora_react_1 = require("@grupoboticario/flora-react");
const flora_react_icons_1 = require("@grupoboticario/flora-react-icons");
const Popover = __importStar(require("@radix-ui/react-popover"));
const web_1 = require("@react-spring/web");
const react_1 = require("react");
const ProductImage_1 = require("../../../../components/ProductImage");
const reduceImageFromUrl_1 = require("../../../../utils/helpers/reduceImageFromUrl");
const ShoppingBagHeaderItem_1 = __importDefault(require("../../molecules/ShoppingBagHeaderItem"));
const ShoppingBagPopover_styled_1 = require("./ShoppingBagPopover.styled");
const useCartMenu_1 = require("../../../../@cart/hooks/useCartMenu");
const BrandThemeProvider_1 = require("../../../../components/BrandThemeProvider/BrandThemeProvider");
const ITEMS_TO_SHOW = 2;
const ANIMATION_CONFIG = {
    from: {
        width: '0%',
    },
    to: {
        width: '100%',
    },
};
const ShoppingBagPopover = ({ totalCartItems, isLoading, cartItems, onClickFinishOrder, onClickItem, onClick, }) => {
    const { state, timer, closePopover } = (0, useCartMenu_1.useCartMenu)();
    const [styles, api] = (0, web_1.useSpring)(() => (Object.assign(Object.assign({}, ANIMATION_CONFIG), { config: {
            gentle: true,
            duration: timer,
            delay: 100,
        } })));
    const [itemsToShow, setItemsToShow] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
        if (cartItems.length === 0) {
            return;
        }
        setItemsToShow(cartItems.slice(0, ITEMS_TO_SHOW));
    }, [cartItems]);
    (0, react_1.useEffect)(() => {
        if (state.isPopoverOpen) {
            api.start(ANIMATION_CONFIG);
        }
    }, [api, state.isPopoverOpen]);
    const handleClickFinishOrder = () => {
        onClickFinishOrder === null || onClickFinishOrder === void 0 ? void 0 : onClickFinishOrder();
        closePopover();
    };
    return ((0, jsx_runtime_1.jsxs)(Popover.Root, Object.assign({ open: state.isPopoverOpen }, { children: [(0, jsx_runtime_1.jsx)(Popover.Anchor, Object.assign({ asChild: true }, { children: (0, jsx_runtime_1.jsx)(ShoppingBagPopover_styled_1.ButtonWrapper, Object.assign({ "data-testid": "shopping-bag-popover-button" }, { children: (0, jsx_runtime_1.jsx)(ShoppingBagHeaderItem_1.default, { isLoading: isLoading, onClick: onClick, totalCartItems: totalCartItems }) })) })), (0, jsx_runtime_1.jsx)(Popover.Portal, { children: (0, jsx_runtime_1.jsxs)(ShoppingBagPopover_styled_1.PopoverContent, Object.assign({ className: BrandThemeProvider_1.currentBrandTheme.className, side: "bottom", align: "end", alignOffset: -15, "data-testid": "shopping-bag-popover-content" }, { children: [(0, jsx_runtime_1.jsx)(ShoppingBagPopover_styled_1.PopoverArrow, {}), (0, jsx_runtime_1.jsxs)(ShoppingBagPopover_styled_1.ContentWrapper, { children: [(0, jsx_runtime_1.jsxs)(ShoppingBagPopover_styled_1.PopoverHeader, { children: [(0, jsx_runtime_1.jsx)(flora_react_icons_1.CheckCircleFillIcon, { "aria-hidden": "true" }), (0, jsx_runtime_1.jsx)(flora_react_1.Text, Object.assign({ as: "h1", size: "exceptionsAuxiliarRegular" }, { children: "Produto adicionado" }))] }), (0, jsx_runtime_1.jsxs)(ShoppingBagPopover_styled_1.PopoverBody, { children: [(0, jsx_runtime_1.jsx)(ShoppingBagPopover_styled_1.PopoverItems, { children: itemsToShow.map((item) => {
                                                var _a;
                                                return ((0, jsx_runtime_1.jsxs)(ShoppingBagPopover_styled_1.PopoverItemWrapper, Object.assign({ onClick: () => onClickItem === null || onClickItem === void 0 ? void 0 : onClickItem(item) }, { children: [(0, jsx_runtime_1.jsx)(ShoppingBagPopover_styled_1.PopoverItemImageWrapper, { children: (0, jsx_runtime_1.jsx)(ProductImage_1.ProductImage, { image: (0, reduceImageFromUrl_1.reduceImageFromUrl)((_a = item.image) !== null && _a !== void 0 ? _a : 'default-image', 48) }) }), (0, jsx_runtime_1.jsx)(ShoppingBagPopover_styled_1.PopoverItemTitleWrapper, { children: (0, jsx_runtime_1.jsx)(flora_react_1.Text, Object.assign({ as: "span", size: "exceptionsAuxiliarRegular" }, { children: item.name })) })] }), item.id));
                                            }) }), (0, jsx_runtime_1.jsx)(flora_react_1.Button, Object.assign({ onClick: handleClickFinishOrder, variant: "ghost", size: "small", isFull: true, css: { marginTop: '$2' } }, { children: "Finalizar compra" }))] }), (0, jsx_runtime_1.jsx)(ShoppingBagPopover_styled_1.PopoverTimeBar, { children: (0, jsx_runtime_1.jsx)(web_1.animated.span, { style: styles }) })] })] })) })] })));
};
exports.ShoppingBagPopover = ShoppingBagPopover;
